import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import ProbSevRiskElement from './ProbSevRiskElement';
import Translator from '../../../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../../../routing/helpers/router'; import colors from '../../../../../../../constants/colors';

const ProbSevRiskBlock = (props) => {
  const { plantObligation } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions
  );
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.userBridge?.permissions
  );
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  const [probability, setProbability] = useState(
    poLevel3[plantObligation]?.probSevRisk?.probability
  );
  const [severity, setSeverity] = useState(
    poLevel3[plantObligation]?.probSevRisk?.severity
  );
  const [risk, setRisk] = useState(
    poLevel3[plantObligation]?.probSevRisk?.risk
  );
  const [showEditModal, setShowEditModal] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setProbability(poLevel3[plantObligation]?.probSevRisk?.probability);
    setSeverity(poLevel3[plantObligation]?.probSevRisk?.severity);
    setRisk(poLevel3[plantObligation]?.probSevRisk?.risk);
  }, [poLevel3]);

  const handleChangeProbSev = async (newState) => {
    setLoading(true);
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evaluation_changeProbSev"),
        {
          moduleBridgeHex,
          plantObligationID: plantObligation,
          plantHex,
          type: showEditModal,
          newState,
        }
      );
      setProbability(response.data.probability);
      setSeverity(response.data.severity);
      setRisk(response.data.risk);

      setShowEditModal(null);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      {permissions?.gcl?.module?.plant?.probSevRisk?.probability && (
        <div
          onClick={() =>
            !permissions.gcl?.module?.submodules?.correctiveActions
              ?.supervisionSystem && permissions?.gcl?.module?.plant?.probSevRisk
              ?.probability !== 'wn' &&
            (userBridgePermissions?.level !== 2 ||
              userBridgePermissions?.writeProvSev === true)
              ? setShowEditModal('prob')
              : undefined
          }
          className={
            permissions?.gcl?.module?.plant?.probSevRisk?.probability !==
              'wn' &&
            (userBridgePermissions?.level !== 2 ||
              userBridgePermissions?.writeProvSev === true)
              ? 'pointer'
              : ''
          }
        >
          <ProbSevRiskElement type="prob" state={probability} />
        </div>
      )}
      {permissions?.gcl?.module?.plant?.probSevRisk?.severity && (
        <div
          onClick={() =>
            permissions?.gcl?.module?.plant?.probSevRisk?.severity !== 'wn' &&
            (userBridgePermissions?.level !== 2 ||
              userBridgePermissions?.writeProvSev === true)
              ? setShowEditModal('sev')
              : undefined
          }
          className={
            permissions?.gcl?.module?.plant?.probSevRisk?.severity !== 'wn' &&
            (userBridgePermissions?.level !== 2 ||
              userBridgePermissions?.writeProvSev === true)
              ? 'pointer mt-4 mb-3'
              : 'mt-4 mb-3'
          }
        >
          <ProbSevRiskElement type="sev" state={severity} />
        </div>
      )}
      {permissions?.gcl?.module?.plant?.probSevRisk?.risk && (
        <ProbSevRiskElement type="risk" state={risk} />
      )}
      <AppModal
        show={showEditModal !== null}
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="modify.value" />
        )}
        onClose={() => setShowEditModal(null)}
      >
        <EditProbSevModal>
          <div
            className={`pointer ${loading ? 'disabled' : ''}`}
            onClick={() => handleChangeProbSev(0)}
          >
            <AppRemixIcon
              className="mr-2"
              icon={
                (showEditModal === 'prob' && probability === 0) ||
                (showEditModal === 'sev' && severity === 0)
                  ? 'radio-button'
                  : 'checkbox-blank-circle'
              }
            />
            <Translator file="filter" name="filter.probability.0" />
          </div>

          <div
            className={`pointer ${loading ? 'disabled' : ''}`}
            onClick={() => handleChangeProbSev(1)}
          >
            <AppRemixIcon
              className="mr-2"
              icon={
                (showEditModal === 'prob' && probability === 1) ||
                (showEditModal === 'sev' && severity === 1)
                  ? 'radio-button'
                  : 'checkbox-blank-circle'
              }
            />
            <Translator file="filter" name="filter.probability.1" />
          </div>
          <div
            className={`pointer ${loading ? 'disabled' : ''}`}
            onClick={() => handleChangeProbSev(2)}
          >
            <AppRemixIcon
              className="mr-2"
              icon={
                (showEditModal === 'prob' && probability === 2) ||
                (showEditModal === 'sev' && severity === 2)
                  ? 'radio-button'
                  : 'checkbox-blank-circle'
              }
            />
            <Translator file="filter" name="filter.probability.2" />
          </div>
          <div
            className={`pointer ${loading ? 'disabled' : ''}`}
            onClick={() => handleChangeProbSev(3)}
          >
            <AppRemixIcon
              className="mr-2"
              icon={
                (showEditModal === 'prob' && probability === 3) ||
                (showEditModal === 'sev' && severity === 3)
                  ? 'radio-button'
                  : 'checkbox-blank-circle'
              }
            />
            <Translator file="filter" name="filter.probability.3" />
          </div>
          <br />
          <span
            className={`btn btn-sm btn-outline-light ${
              loading ? 'disabled' : ''
            }`}
            onClick={() => handleChangeProbSev(null)}
          >
            <Translator file="filter" name="filter.default" />
          </span>
          {/* <div className={`pointer ${loading ? 'disabled' : ''}`} > */}
          {/*  <AppRemixIcon */}
          {/*    className="mr-2" */}
          {/*    icon={(showEditModal === 'prob' && probability === null) || (showEditModal === 'sev' && severity === null) ? 'radio-button' : 'checkbox-blank-circle'} */}
          {/*  /> */}
          {/*  <Translator file="filter" name="filter.default" /> */}
          {/* </div> */}
        </EditProbSevModal>
      </AppModal>
    </>
  );
};
export default ProbSevRiskBlock;

const EditProbSevModal = styled.div`
div{
  display: flex;
  align-items: center;
}
.disabled{
  color: ${colors.grey300}
}
`;
